import { cn } from '@pcln/horizon'

const cruiseFormVariants = {
  default: {
    gridContainer:
      'grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_max-content]'
  },
  // Compact variant - maintain sm layout through lg for homepage hero
  // Row 1: Destination, Departure (each 3 cols)
  // Row 2: Cruise length, Cruise line, Search (each 2 cols)
  compact: {
    gridContainer: [
      'grid grid-cols-1 gap-3',
      'sm:grid-cols-6',
      "sm:[grid-template-areas:'destination_destination_destination_departure_departure_departure'_'length_length_line_line_search_search']"
    ]
  }
} as const

type CruiseTypeVariant = keyof typeof cruiseFormVariants

export const getGridContainerClass = (useCompactLayout = false) => {
  const variant: CruiseTypeVariant = useCompactLayout ? 'compact' : 'default'
  return cn(cruiseFormVariants[variant].gridContainer, 'mx-auto')
}

export const getSubmitButtonClass = (
  isMobile: boolean,
  useCompactLayout = false
) => {
  if (isMobile) {
    return 'fixed bottom-4 right-4 left-4 sm:[grid-area:search]'
  }
  if (useCompactLayout) {
    return 'w-full sm:[grid-area:search]'
  }
  return 'w-full sm:col-span-2 lg:col-span-1'
}

const inputClassMap = {
  destination: 'sm:[grid-area:destination]',
  departure: 'sm:[grid-area:departure]',
  length: 'sm:[grid-area:length]',
  line: 'sm:[grid-area:line]'
} as const

export const getInputClass = (
  type: 'destination' | 'departure' | 'length' | 'line',
  useCompactLayout = false
) => {
  if (!useCompactLayout) {
    return ''
  }
  return inputClassMap[type]
}
